import { dateFormatString } from 'common-app/options';
import { dateFormat, formatToIsoStringCalendar } from '@isyc-react/form/modules/date';
import { parametersToRecordByCode } from 'common-app/types';
export const occupantApiToForm = occupant => {
    var _a, _b, _c;
    return occupant
        ? {
            id: occupant.id,
            erasable: Boolean(occupant.erasable),
            sex: occupant.sex ? { value: occupant.sex.toString() } : null,
            birthName: (_a = occupant.birthName) !== null && _a !== void 0 ? _a : '',
            firstname: (_b = occupant.firstname) !== null && _b !== void 0 ? _b : '',
            surname: (_c = occupant.surname) !== null && _c !== void 0 ? _c : '',
            birthDate: occupant.birthDate ? dateFormat(occupant.birthDate, dateFormatString) : '',
            parameters: parametersToRecordByCode(occupant.parameters)
        }
        : {
            id: null,
            erasable: true,
            sex: null,
            birthName: '',
            firstname: '',
            surname: '',
            birthDate: '',
            parameters: {}
        };
};
export const occupantFormToApi = occupant => {
    var _a, _b;
    return {
        id: occupant.id,
        sex: (_a = occupant.sex) === null || _a === void 0 ? void 0 : _a.value,
        birthName: occupant.birthName,
        firstname: occupant.firstname,
        surname: occupant.surname,
        birthDate: occupant.birthDate
            ? (_b = formatToIsoStringCalendar(occupant.birthDate, dateFormatString)) !== null && _b !== void 0 ? _b : undefined
            : undefined,
        parameters: Object.values(occupant.parameters).map(p => ({ id: p.id, code: p.code, value: p.value }))
    };
};
